/**
 * Feature Flags
 *
 * These constants map to feature flags returned from the backend in:
 * sessionResponse.userInfo.monolith_tenants[0].features
 *
 * Add new feature flag constants here as they're introduced in the backend.
 */
export const FEATURES = {
  NEW_TASK_SYSTEM: "new_task_system",
  TEST_FEATURE1: "test_feature1",
  TEST_FEATURE2: "test_feature2",
  TEST_FEATURE3: "test_feature3",
  TEST_FEATURE4: "test_feature4",
  EVIDENCE_ALLOW_ALL_BULK_COC: "evidence:allow_all_bulk_coc",
  ACQUISITIONS_CSV_IMPORT: "acquisitions:csv-import",
  EVIDENCE_CSV_IMPORT: "evidence:csv-import",
  NOTES_AND_REPORTS_TABLE_SUPPORT: "notes_reports_table_support",
  EDISCOVERY_ALL_FEATURES: "ediscovery:all-features",
  LAB_ASSETS: "lab_assets",
  // Shows the managed "Evidence Files" tree in the Files tab. Gated on the
  // backend at the Files read paths (ENG-1785). The app branches on it only
  // for the evidence item Files tab (ENG-2156), which browses that tree.
  EVIDENCE_FILES_IN_CASE_FILES: "evidence_files_in_case_files",
  // Gates the storage-photos routes on the backend (404 while off). Must match
  // the key in the API's src/services/features/features.ts.
  STORAGE_PHOTOS: "storage_photos",
  // The evidence table's Print Labels action and the single item print dialog
  // (ENG-1871). App only, no backend gate. While off, single item print keeps
  // the old template submenu and SelectPrinterModal (cleanup is ENG-2238).
  BULK_LABEL_PRINTING: "bulk_label_printing",
} as const;

export type Features = typeof FEATURES[keyof typeof FEATURES];
